var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPaymentHelplineIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_12595",
    "data-name": "Group 12595",
    transform: "translate(-22664 354)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_462",
    "data-name": "Ellipse 462",
    cx: 17,
    cy: 17,
    r: 17,
    transform: "translate(22664 -354)",
    fill: "#d71920"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5140",
    "data-name": "Path 5140",
    d: "M14.73,13c-.463,1.407-2.277,2.109-3.573,1.992A11.4,11.4,0,0,1,6,12.855,16.989,16.989,0,0,1,.664,6.489,5.342,5.342,0,0,1,.882.951,2.12,2.12,0,0,1,2.572,0C3.6-.047,3.744.541,4.1,1.457c.263.685.614,1.384.81,2.094.367,1.325-.916,1.38-1.078,2.463-.1.683.727,1.6,1.1,2.086a10.105,10.105,0,0,0,2.608,2.4c.57.359,1.488,1.006,2.14.649,1-.55.91-2.243,2.313-1.67a22.59,22.59,0,0,1,2.125,1.1c1.073.577,1.023,1.175.614,2.417h0",
    transform: "translate(22674 -345)",
    fill: "#fff",
    fillRule: "evenodd"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaymentHelplineIcon);
export default __webpack_public_path__ + "static/media/PaymentHelplineIcon.a943bc4b932a13004d9fa07a12424fd4.svg";
export { ForwardRef as ReactComponent };